import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

/** Foglio di stile già pronto: in Firefox leggere `cssRules` mentre si scarica lancia un errore. */
function isLoaded(link: HTMLLinkElement): boolean {
  try {
    return Boolean(link.sheet?.cssRules)
  } catch {
    return false
  }
}

/**
 * I fogli di stile del sito (non i font di Google), finché arrivano. Firefox disegna la pagina appena uno script ne
 * misura il layout: se l'idratazione parte prima del CSS (JS dalla cache, CSS ancora in rete) si vede l'HTML grezzo,
 * con il logo SVG enorme su fondo bianco. Chrome aspetta comunque il CSS, quindi lì non cambia nulla.
 */
function siteStylesheets(): Promise<unknown> {
  const pending = [...document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')].filter(
    (link) => new URL(link.href, location.href).origin === location.origin && !isLoaded(link),
  )
  return Promise.all(
    pending.map(
      (link) =>
        new Promise((resolve) => {
          link.addEventListener('load', resolve, { once: true })
          link.addEventListener('error', resolve, { once: true })
        }),
    ),
  )
}

// Come l'entry predefinita di React Router, ma l'idratazione aspetta il CSS del sito.
siteStylesheets().then(() =>
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <HydratedRouter />
      </StrictMode>,
    )
  }),
)
